import React from 'react';
import { FeatureExplanationColumnBlock } from '@models/feature-explanation';
import { ColoredExplanationBlock } from './ColoredExplanationBlock';

export const ColumnExplanationBlock: React.FC<
  FeatureExplanationColumnBlock
> = block => (
  <ColoredExplanationBlock block={block}>
    {block.columnName}
  </ColoredExplanationBlock>
);
